import '../../styles-new/pages/editorial-charter.scss';